<div class={{this.wrapperClass}}>
  <input
    {{did-insert this.setup}}
    disabled={{this.uppyUpload.uploading}}
    id={{this.inputId}}
    class="hidden-upload-field"
    type="file"
    accept={{this.field.file_types}}
    style="visibility: hidden; position: absolute;"
  />
  <DButton
    @translatedLabel={{this.uploadLabel}}
    @translatedTitle={{this.uploadLabel}}
    @icon="upload"
    @disabled={{this.uppyUpload.uploading}}
    @action={{this.chooseFiles}}
    class="wizard-btn wizard-btn-upload-file"
  />
  {{#if this.field.value}}
    {{#if this.isImage}}
      <img src={{this.field.value.url}} class="wizard-image-preview" />
    {{else}}
      {{this.field.value.original_filename}}
    {{/if}}
  {{/if}}
</div>